import React from 'react';
import { Result, Flex } from 'antd';
import SuccessIcon from './SuccessIcon';

const LastSectionCompletionModal = () => (
  <Result
    style={{ height: '130px', padding: 0 }}
    icon={
      <Flex justify="center">
        <SuccessIcon />
      </Flex>
    }
    status="success"
    title="End of Test"
  />
);

export default LastSectionCompletionModal;
